import React from 'react';
import { Container, Modal, Row, Col } from 'react-bootstrap';
import { Form, InputGroup, Button } from 'react-bootstrap';
import { BsSearch } from 'react-icons/bs';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const SideModal = ({ show, handleClose }) => {
    const citizenBodyRefCitizen = useRef(null);
    const citizenModalInfoRefCitizen = useRef(null);
    const navigate = useNavigate()

    return (
        <Modal show={show} onHide={handleClose} className='citizen-modal'>
            <div className='citizenmodal-info1 citizenmodal-info' ref={citizenModalInfoRefCitizen}>
                {/* <img src="images/citizen-bg.png" alt="Logo" className='w-100' /> */}
                <div className='citizen-body' ref={citizenBodyRefCitizen}>
                    <Modal.Header closeButton className='mx-5 px-0'>
                        <Modal.Title> <a className="navbar-brand d-flex align-items-center" href="#">
                            <img src="images/logo.svg" className='logo'
                                alt="Logo" />
                            <div className="brand-text ms-2">
                                <img src="images/logo-text.svg"
                                    className='logo-text' alt="Logo Text" />
                            </div>
                        </a></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

<div
                            className='modalbody-head  mx-5'>
                            <div
                                className='stat-head ms-5 d-flex'>
                                <h4>More<br /><span>Links</span></h4>
                            </div>
                        </div>
                        <Container>
                            <Row>
                                <Col xxl={6} xl={6} md={12} lg={6} xs={12} sm={12}>
                                    {/* <span className='tax-head3'>Property </span> */}

                                    <ul className='tax-ul ps-0 ps-2 pe-2'>
                                        {/* <li className='pb-2' onClick={(e) => { navigate("/SelfAssessmentForm") }}>Apply For New Assessment</li> */}
                                        <li
                                            className='pb-2'
                                            onClick={() => navigate("/outsearchgos")}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    navigate("/outsearchgos");
                                                }
                                            }}
                                            role="button"
                                            tabIndex={0}
                                        >
                                            GO's and Circulars
                                        </li>
                                        {/* <li className='pb-2 pt-2' onClick={(e) => { navigate("/AditionAlterition") }}>Addition/ Alteration</li> */}
                                        <li
                                            className='pb-2 pt-2'
                                            onClick={() => navigate("/outnotification")}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    navigate("/outnotification");
                                                }
                                            }}
                                            role="button"
                                            tabIndex={0}
                                        >
                                            Careers
                                        </li>
                                        <li
                                            className='pb-2 pt-2'
                                            onClick={() => navigate("/GalleryPage")}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    navigate("/GalleryPage");
                                                }
                                            }}
                                            role="button"
                                            tabIndex={0}
                                        >
                                            Gallery
                                        </li>
                                        <li
                                            className='pb-2 pt-2'
                                            onClick={() => navigate("/Contactus")}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    navigate("/Contactus");
                                                }
                                            }}
                                            role="button"
                                            tabIndex={0}
                                        >
                                            Contact Us
                                        </li>


                                    </ul>

                                </Col>

                            </Row>
                        </Container>
                    </Modal.Body>
                </div>
            </div>

        </Modal>
    );
};

export default SideModal;